let activeCapability: string | null = null;

export const setCapability = (capability: string | null) => {
	activeCapability = capability;
};

export const getCapability = () => activeCapability;
